/**
 * /frontend/src/features/analytics/utils/formatters.js
 */

/**
 * Ensures numeric output.
 * @param {unknown} value
 * @param {number} fallback
 * @returns {number}
 */
export const asNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

/**
 * Ensures string output.
 * @param {unknown} value
 * @param {string} fallback
 * @returns {string}
 */
export const asText = (value, fallback = '') => {
  if (value === null || value === undefined) return fallback;
  const parsed = String(value).trim();
  return parsed || fallback;
};

/**
 * Formats minutes to a label.
 * @param {unknown} value
 * @returns {string}
 */
export const formatMinutes = (value) => `${asNumber(value).toFixed(1)} min`;

/**
 * Formats days to a label.
 * @param {unknown} value
 * @returns {string}
 */
export const formatDays = (value) => `${asNumber(value).toFixed(2)} d`;

/**
 * Formats percent to a label.
 * @param {unknown} value
 * @returns {string}
 */
export const formatPercent = (value) => `${asNumber(value).toFixed(1)}%`;

/**
 * Formats currency for INR.
 * @param {unknown} value
 * @returns {string}
 */
export const formatCurrencyInr = (value) => `₹${asNumber(value).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;

